
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import ReactGA from "react-ga4";
import { applySecurityHeaders } from "./utils/security/securityHeaders";

// Apply security headers
applySecurityHeaders();

// Initialize Google Analytics with error handling
try {
  const GA_MEASUREMENT_ID = "G-FCMHK96H3W";
  if (GA_MEASUREMENT_ID) {
    ReactGA.initialize(GA_MEASUREMENT_ID);
  }
} catch (error) {
  console.warn("Failed to initialize Google Analytics:", error);
}

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
